<dx-select-box [dataSource]="connectionTypes"
               [(value)]="connectionType"
               (valueChange)="connectionTypeChange.emit($event)"
               [isValid]="!!connectionType">
</dx-select-box>
